import { createRoot, type Root } from 'react-dom/client';
import { App } from './App';
import { initSentry } from './shared/sentry';
import { captureAutoCouponFromUrl } from './booking/checkout/autoCoupon';
import type { MountProps } from './types';
import './styles.css';

const roots = new WeakMap<HTMLElement, Root>();

export function mount(el: HTMLElement, props: MountProps): { unmount: () => void } {
  initSentry(props.sentry);

  // Capture a deep-link coupon (?coupon=…, MVK-2468) from the landing URL before
  // React renders — react-router drops the query on funnel navigation, so the
  // checkout reads it back from sessionStorage instead. Booking flow only.
  if (props.mode === 'booking') captureAutoCouponFromUrl(window.location.search);

  const existing = roots.get(el);
  if (existing) existing.unmount();

  const root = createRoot(el);
  root.render(<App {...props} />);
  roots.set(el, root);

  return {
    unmount: () => {
      roots.get(el)?.unmount();
      roots.delete(el);
    },
  };
}

window.MoveekBooking = { mount, version: __APP_VERSION__ };
